import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// React
import React, { useCallback, useContext, useEffect, useState, useImperativeHandle } from 'react';

// Libs
import i18n from '../i18n';

// MUI
import { Box, Grid, Typography } from '@mui/material';

//interfaces

//context
import { UserDetailsContext } from '../context/userContext';

//utils
import { modifyFields, handleErr, cloneObject, modifyDynamicFormAttributes, isEmpty, colSize } from '../utils/util';

//components
import TextFieldComponent, { TextFieldsDisplay } from './textFieldComponent';
import AccordionComponent from './accordionComponent';
import RegisterDocumentDetails from './registerDocumentDetails';
import { CompanyDetailsContext } from '../context/companyContext';
function CustomOnboardingForm(props, ref) {
  var _props$displayFields2;
  var _useContext = useContext(UserDetailsContext),
    userData = _useContext.userData,
    setUserDetailsFromInput = _useContext.setUserDetailsFromInput;
  var _useContext2 = useContext(CompanyDetailsContext),
    companyData = _useContext2.companyData;
  var _useState = useState(cloneObject(props === null || props === void 0 ? void 0 : props.displayFields)),
    _useState2 = _slicedToArray(_useState, 2),
    userInfoFieldsState = _useState2[0],
    setUserInfoFieldsState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayError = _useState4[0],
    setDisplayError = _useState4[1];
  var errorDetails = [];
  var modifyUserFields = function modifyUserFields(fieldName, fieldValue, attributeName, validationFlag, validationMessage) {
    setUserInfoFieldsState(modifyFields(fieldName, fieldValue, attributeName, validationFlag, validationMessage, userInfoFieldsState));
  };
  var updateFieldValue = function updateFieldValue(name, value) {
    setUserDetailsFromInput(_objectSpread(_objectSpread({}, userData), {}, {
      user: _objectSpread(_objectSpread({}, userData.user), {}, _defineProperty({}, name, value))
    }));
  };
  useEffect(function () {
    setUserInfoFieldsState(cloneObject(props === null || props === void 0 ? void 0 : props.displayFields));
    (props === null || props === void 0 ? void 0 : props.booleanFunc) && (props === null || props === void 0 ? void 0 : props.booleanFunc(false));
  }, [props === null || props === void 0 ? void 0 : props.order]);
  var getValue = function getValue(fieldItem) {
    var value = fieldItem.value ? fieldItem.value : userData === null || userData === void 0 ? void 0 : userData.user[fieldItem.fieldName];
    (fieldItem.value || (userData === null || userData === void 0 ? void 0 : userData.user[fieldItem.fieldName])) && setUserInfoFieldsState(modifyDynamicFormAttributes(props === null || props === void 0 ? void 0 : props.displayFields, fieldItem.fieldName, value));
    return value;
  };
  useEffect(function () {
    var _props$displayFields;
    var preFilledValues = [];
    props === null || props === void 0 || (_props$displayFields = props.displayFields) === null || _props$displayFields === void 0 || _props$displayFields.flatMap(function (displayItem) {
      var _displayItem$fields;
      return (_displayItem$fields = displayItem.fields) !== null && _displayItem$fields !== void 0 ? _displayItem$fields : [];
    }).forEach(function (fieldItem) {
      if (!Array.isArray(fieldItem)) {
        if (getValue(fieldItem)) preFilledValues.push([fieldItem.fieldName, getValue(fieldItem)]);
      } else {
        fieldItem.forEach(function (fieldInnerItem) {
          if (getValue(fieldInnerItem)) preFilledValues.push([fieldInnerItem.fieldName, getValue(fieldInnerItem)]);
        });
      }
    });
    for (var _i = 0, _Object$entries = Object.entries(userData === null || userData === void 0 ? void 0 : userData.user); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      value && preFilledValues.push([key, value]);
    }
    var initialUserData = Object.fromEntries(preFilledValues);
    Object.keys(initialUserData).length && setUserDetailsFromInput(_objectSpread(_objectSpread({}, userData), {}, {
      user: initialUserData
    }));
  }, [props === null || props === void 0 ? void 0 : props.order]);
  var handleInputChange = function handleInputChange(event, regexPattern, fieldItem) {
    var _fieldItem$onChangeFi;
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    updateFieldValue(name, value);
    var userDetails = cloneObject(userData.user);
    userDetails[name] = value;
    (_fieldItem$onChangeFi = fieldItem.onChangeField) === null || _fieldItem$onChangeFi === void 0 || _fieldItem$onChangeFi.call(fieldItem, {
      fieldName: name,
      value: value,
      stepData: userDetails
    });
    setUserInfoFieldsState(modifyDynamicFormAttributes(userInfoFieldsState, name, value));
    if (regexPattern) {
      modifyUserFields(name, value, '', !new RegExp(regexPattern.source, regexPattern.flags).test(event.target.value), "".concat(i18n.t('REGISTRATION.IS_INVALID', {
        displayName: i18n.t(fieldItem.fieldLabel)
      })));
    }
  };
  var getFieldsDisplay = useCallback(function (item, index) {
    var fieldValue = '';
    fieldValue = (userData === null || userData === void 0 ? void 0 : userData.user[item.fieldName]) !== undefined ? userData === null || userData === void 0 ? void 0 : userData.user[item.fieldName] : item.value;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: colSize(item.colXsSize),
      sm: colSize(item.colLgSize),
      md: colSize(item.colLgSize),
      lg: colSize(item.colLgSize)
    }, item.isVisible && /*#__PURE__*/React.createElement(TextFieldComponent, {
      index: index,
      fieldItem: item,
      fieldValue: fieldValue,
      inputHandler: handleInputChange,
      blurHandlerWithRegex: handleInputChange,
      errorDetails: errorDetails,
      displayError: displayError,
      optionDisplay: function optionDisplay() {
        return '';
      }
    }));
  }, [userInfoFieldsState, displayError, errorDetails]);
  useImperativeHandle(ref, function () {
    return {
      handleSaveAndNext: function handleSaveAndNext() {
        if (handleErr('', false, errorDetails).errorDetails.length === 0) {
          var _props$dynamicForm;
          setDisplayError(false);
          if ((props === null || props === void 0 || (_props$dynamicForm = props.dynamicForm) === null || _props$dynamicForm === void 0 || (_props$dynamicForm = _props$dynamicForm.steps) === null || _props$dynamicForm === void 0 ? void 0 : _props$dynamicForm.length) === (props === null || props === void 0 ? void 0 : props.order)) {
            var companyDataObject = {
              'userData': Object.fromEntries(Object.entries(userData === null || userData === void 0 ? void 0 : userData.user).filter(
              // ignoring the below rule so that code can be reused for custom onboarding also
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  _ = _ref2[0],
                  value = _ref2[1];
                return !isEmpty(value);
              })),
              'documents': companyData.documents
            };
            // for custom onboarding form
            props === null || props === void 0 || props.successHandler({
              companyRegStatusDescription: 'Submitted successfully',
              companyId: '',
              status: '',
              userId: '',
              companyData: companyDataObject
            });
            props === null || props === void 0 || props.setOpenRegisterModal(false);
          } else props === null || props === void 0 || props.handleActiveTab((props === null || props === void 0 ? void 0 : props.order) + 1);
        } else {
          setDisplayError(true);
        }
      }
    };
  });
  var headingSection = function headingSection(heading, desc) {
    return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
      sx: {
        fontWeight: 'bold'
      }
    }, i18n.t(heading)), desc && /*#__PURE__*/React.createElement(Typography, {
      key: desc,
      component: "p",
      sx: {
        fontSize: '0.8rem'
      },
      color: "secondary.dark"
    }, i18n.t(desc)), /*#__PURE__*/React.createElement(Box, {
      component: 'div',
      sx: {
        marginTop: '13px'
      }
    }, (props === null || props === void 0 ? void 0 : props.stepContent) && (props === null || props === void 0 ? void 0 : props.stepContent())));
  };
  var contentSection = function contentSection(sections) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      sx: {
        paddingTop: '18px'
      }
    }, /*#__PURE__*/React.createElement(TextFieldsDisplay, {
      fieldItem: sections,
      callback: getFieldsDisplay
    })));
  };
  var getDisplay = function getDisplay(fields) {
    return fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
      var _item$fields;
      return !item.isAccordion ? /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.sectionName
      }, headingSection(item.sectionName, item.description), contentSection(item.fields)) : ((_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.sectionName
      }, /*#__PURE__*/React.createElement(AccordionComponent, {
        sections: item,
        index: index,
        headerCallback: headingSection,
        contentCallback: contentSection,
        type: "fieldType"
      }));
    });
  };
  var getBooleanValue = function getBooleanValue(value) {
    var _props$booleanFunc;
    props === null || props === void 0 || (_props$booleanFunc = props.booleanFunc) === null || _props$booleanFunc === void 0 || _props$booleanFunc.call(props, value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, getDisplay(userInfoFieldsState))), props === null || props === void 0 || (_props$displayFields2 = props.displayFields) === null || _props$displayFields2 === void 0 ? void 0 : _props$displayFields2.map(function (section) {
    var _section$documents, _props$consentSection;
    if ((_section$documents = section.documents) !== null && _section$documents !== void 0 && _section$documents.length || props !== null && props !== void 0 && props.consentSection && (props === null || props === void 0 || (_props$consentSection = props.consentSection) === null || _props$consentSection === void 0 ? void 0 : _props$consentSection.length) > 0) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RegisterDocumentDetails, {
        consentSection: props === null || props === void 0 ? void 0 : props.consentSection,
        displayFields: props === null || props === void 0 ? void 0 : props.displayFields,
        axiosInstance: props === null || props === void 0 ? void 0 : props.axiosInstance,
        dynamicForm: props === null || props === void 0 ? void 0 : props.dynamicForm,
        clientToken: '1a2b3c',
        setOpenRegisterModal: props === null || props === void 0 ? void 0 : props.setOpenRegisterModal,
        countryCode: '',
        handleActiveTab: props === null || props === void 0 ? void 0 : props.handleActiveTab,
        setLoader: function setLoader(value) {
          return props === null || props === void 0 ? void 0 : props.setLoader(value);
        },
        setSnackbar: function setSnackbar(value) {
          return props === null || props === void 0 ? void 0 : props.setSnackbar(value);
        },
        setSnackBarMessage: function setSnackBarMessage(message) {
          return props === null || props === void 0 ? void 0 : props.setSnackBarMessage(message);
        },
        setSnackBarSeverity: function setSnackBarSeverity(severity) {
          return props === null || props === void 0 ? void 0 : props.setSnackBarSeverity(severity);
        },
        successHandler: props === null || props === void 0 ? void 0 : props.successHandler,
        errorHandler: props === null || props === void 0 ? void 0 : props.errorHandler,
        booleanFunc: getBooleanValue
      }));
    }
    return null;
  }));
}
;
CustomOnboardingForm.displayName = 'CustomOnboardingForm';
var CustomOnboardingFormWrapper = /*#__PURE__*/React.forwardRef(CustomOnboardingForm);
export default CustomOnboardingFormWrapper;